export default [
  { label: '德国', value: '德国' },
  { label: '法国', value: '法国' },
  { label: '荷兰', value: '荷兰' },
  { label: '比利时', value: '比利时' },
  { label: '卢森堡', value: '卢森堡' },
  { label: '瑞士', value: '瑞士' },
  { label: '圣马力诺', value: '圣马力诺' },
  { label: '梵蒂冈', value: '梵蒂冈' },
  { label: '列支敦士登', value: '列支敦士登' },
  { label: '意大利', value: '意大利' },
  { label: '希腊', value: '希腊' },
  { label: '西班牙', value: '西班牙' },
  { label: '安道尔', value: '安道尔' },
  { label: '葡萄牙', value: '葡萄牙' },
  { label: '波兰', value: '波兰' },
  { label: '捷克', value: '捷克' },
  { label: '斯洛伐克', value: '斯洛伐克' },
  { label: '匈牙利', value: '匈牙利' },
  { label: '立陶宛', value: '立陶宛' },
  { label: '爱沙尼亚', value: '爱沙尼亚' },
  { label: '拉脱维亚', value: '拉脱维亚' },
  { label: '芬兰', value: '芬兰' },
  { label: '瑞典', value: '瑞典' },
  { label: '挪威', value: '挪威' },
  { label: '丹麦', value: '丹麦' },
  { label: '斯洛文尼亚', value: '斯洛文尼亚' },
];



// WEBPACK FOOTER //
// ./src/pages/application/consts/schengen-country.js